export class ContentsMandatory {
    $key: string;
    category: string;
    eventId: string;
    extension: string;
    filename: string;
    sizeInBytes: number;
    fileType: string;
    fileUrl: string;

}


// WEBPACK FOOTER //
// /app/src/app/core/models/contents-mandatory.ts